import { POPUPS } from '@common/constants/popups';

import CheckTicketPopup from '@tickets/components/checkTicketPopup';
import TicketDetailsPopup from '@tickets/modules/ticketDetails';
import CashoutPopup from '@tickets/components/cashoutPopup';
import ConfirmationModal from '@tickets/components/confirmationModal';
import WithdrawalAmountPopup from '@app/dev/terminal/components/withdrawal';
import WithdrawalConfirmPopup from '@app/dev/terminal/components/withdrawal/confirmPopup';
import VerificationPopup from '@common/components/popups/verification';
import InfoPopup from '@common/components/popups/info';
import VerificationLogoutPopup from '@common/components/popups/verification/logout';
import ProcessPopup from '@common/components/popups/process';
import JackpotListPopup from "@common/components/jackpot/list";
import SignIn from '../terminal/containers/signIn';
import SignUp from '../terminal/containers/signUp';
import CashIn from '../terminal/components/cashIn';
import Cashout from '../terminal/components/cashout';
import ForgotPassword from '../terminal/containers/forgotPassword';
import DmsSuccess from '../terminal/components/dmsSuccess';
import BetBuilderWrapper from '../terminal/containers/betBuilderWrapper';
import CashOutType from '../terminal/components/cashouttype';
import LockTerminal from '../terminal/components/lockTerminal';
import SuccessPopup from '../terminal/components/successPopup';
import TerminalError from '../terminal/components/terminalError';
import SetPinCode from '../terminal/components/setPinCode';
import { LogoutConfirmation } from '../terminal/containers/logoutConfirmation';
import OddsFormatSelect from '../terminal/components/oddsFormat';
import { DepositByPix } from '../terminal/components/depositByPix';
import { CashoutByPix } from '../terminal/components/cashoutByPix';
import CashoutByTicket from '../terminal/components/cashoutbyticket';
import ResetPinCode from '../terminal/components/resetPinCode';
import StaffLoginPopup from '../terminal/components/staffLoginPopup';
import { CashoutMethods } from '../terminal/components/cashoutMethods';
import StatisticsPopup from '../components/statisticsPopup';
import CashoutByBankCard from '../terminal/components/cashoutByBankCard';
import VideoStreamPopup from '../components/videoStreamPopup';
import TermsAndConditions from '../terminal/components/termsAndConditions';
import { SuccessReset } from '../terminal/containers/forgotPassword/pieces/SuccessReset';
import LoyalCardInputPopup from '../terminal/components/LoyalCardInputPopup';
import SuccessRegistration from '../terminal/containers/signUp/pieces/SuccessRegistration';
import ErrorLoggedInRFID from '../terminal/components/errorLoggedInRFID';
import TerminalLockReminderPopup from '../terminal/components/terminalLockReminderPopup';
import LoginForm from '../terminal/components/loginForm';
import ChangePasswordForm from '../terminal/components/changePasswordForm';
import { InactiveTerminal } from '../terminal/components/inactivepopup';
import ErrorPopup from '../terminal/components/errorPopup';
import FailPopup from '../terminal/components/failPopup';
import Superbet from '../terminal/components/superbet';
import RegisterByCNPPopup from '../terminal/components/registerByCNPPopup';
import RfidCheck from '../terminal/components/rfidCheckpopup';
import RegisterSuccess from '../terminal/components/confirmationPopup';
import WinIdentificationPopup from '../terminal/components/winIdentificationPopup';
import LoginByPinCode from '../terminal/components/loginByPinCode';
import DepositPopup from '../terminal/containers/depositMethods';
import ChooseDepositMethodPopup from '../terminal/components/chooseDepositMethod';
import { PrintBookingTicket } from '../terminal/components/printBookingTicket';
import VerificationLoading from '../terminal/containers/clientVerification/idVerification/components/loading';
import VerificationSuccess from '../terminal/containers/clientVerification/idVerification/components/success';
import PassportVerificationInfo from '../terminal/containers/clientVerification/idVerification';
import VerificationLogOut from '../terminal/containers/clientVerification/idVerification/components/logOut';
import VerificationInactive from '../terminal/containers/clientVerification/idVerification/components/inactive';
import { CashoutOctopay } from '../terminal/containers/cashoutMethods/octopay';
import { NonCashInactivePopup } from '../terminal/components/nonCashInactivePopup';
import ProfitBoostWheel from '../components/profitBoostWheel';
import ProfitBoostInfo from '../components/profitBoostInfo';
import PayoutRequest from '../terminal/components/requestPayoutPopup';
import { IframePopup } from '../terminal/components/iframePopup';
import EmbedPopup from '../terminal/components/embedPopup';
import RegistrationForm from '../terminal/containers/registrationNewForm';
import { TerminalUsageConfirmationPopup } from '../terminal/components/terminalUsageConfirmationPopup';
import SuccessPopupWithBenefits from '../terminal/components/successPopupWIthBenefits';
import ClientDepositPopup from '../terminal/containers/clientDepositPopup';
import CnpVerificationPopup from '@app/dev/terminal/components/autofillVerificationByCnpPopup';
import ClientDepositFailPopup from '../terminal/containers/clientDepositFailPopup';
import { MpesaDeposit } from '../terminal/components/mpesaDeposit';
import { DepositPendingPopup } from '../terminal/components/depositPendingPopup';
import { MpesaWithdraw } from '../terminal/components/mpesaWithdraw';
import TransferToUser from '../terminal/containers/cashoutMethods/transferToUser';
import DigitalCashout from '../terminal/components/digitalCashout';

export const popupsList = {
  [POPUPS.TERMINAL_USAGE_CONFIRMATION_POPUP]: TerminalUsageConfirmationPopup,
  [POPUPS.CASH_IN]: CashIn,
  [POPUPS.SIGN_UP]: SignUp,
  [POPUPS.SIGN_IN]: SignIn,
  [POPUPS.CASHOUT]: Cashout,
  [POPUPS.DEPOSIT]: DepositPopup,
  [POPUPS.MPESA_DEPOSIT]: MpesaDeposit,
  [POPUPS.MPESA_WITHDRAW]: MpesaWithdraw,
  [POPUPS.DEPOSIT_PENDING]: DepositPendingPopup,
  [POPUPS.CHOOSE_DEPOSIT_METHOD]: ChooseDepositMethodPopup,
  [POPUPS.SUPERBET]: Superbet,
  [POPUPS.LOGIN_FORM]: LoginForm,
  [POPUPS.DMS_SUCCESS]: DmsSuccess,
  [POPUPS.FAIL_POPUP]: FailPopup,
  [POPUPS.CASHOUT_TYPE]: CashOutType,
  // [POPUPS.DMS_CASHOUT]: DmsCashout,
  [POPUPS.ERROR_POPUP]: ErrorPopup,
  [POPUPS.TERMINAL_ERROR]: TerminalError,
  [POPUPS.LOCK_TERMINAL]: LockTerminal,
  [POPUPS.CASHOUT_POPUP]: CashoutPopup,
  [POPUPS.SUCCESS_POPUP]: SuccessPopup,
  [POPUPS.SUCCESS_POPUP_WITH_BENEFITS]: SuccessPopupWithBenefits,
  [POPUPS.CASHOUT_BY_PIX]: CashoutByPix,
  [POPUPS.DEPOSIT_BY_PIX]: DepositByPix,
  [POPUPS.STAFF_LOGIN]: StaffLoginPopup,
  [POPUPS.BET_BUILDER]: BetBuilderWrapper, // but ??
  [POPUPS.VIDEO_STREAM]: VideoStreamPopup, // heto knayvi
  [POPUPS.FORGOT_PASSWORD]: ForgotPassword,
  [POPUPS.CASHOUT_METHODS]: CashoutMethods,
  [POPUPS.RESET_SUCCESS]: SuccessReset,
  [POPUPS.SET_PIN_CODE]: SetPinCode,
  // [POPUPS.LOCK_AND_UNLOCK]: LockAndUnlock,
  [POPUPS.STATISTICS_POPUP]: StatisticsPopup,
  [POPUPS.CASHOUT_BY_TICKET]: CashoutByTicket,
  [POPUPS.LOGIN_BY_PIN_CODE]: LoginByPinCode,
  [POPUPS.RESET_PIN_CODE]: ResetPinCode,
  [POPUPS.ODDS_FORMAT_SELECT]: OddsFormatSelect, // heto knayem es parz chi hl@
  [POPUPS.CONFIRMATION_MODAL]: ConfirmationModal,
  [POPUPS.INACTIVE_TERMINAL]: InactiveTerminal,
  [POPUPS.CASHOUT_BY_BANK_CARD]: CashoutByBankCard, // check is it using
  [POPUPS.ERROR_LOGGED_IN_RFID]: ErrorLoggedInRFID,
  [POPUPS.LOGOUT_CONFIRMATION]: LogoutConfirmation, // chekcked
  [POPUPS.TERMS_AND_CONDITIONS]: TermsAndConditions,
  [POPUPS.CHANGE_PASSWORD_FORM]: ChangePasswordForm,
  [POPUPS.REGISTRATION_SUCCESS]: SuccessRegistration,
  [POPUPS.LOYAL_CARD_INPUT_POPUP]: LoyalCardInputPopup,
  // [POPUPS.MULTIPLE_TICKETS_POPUP]: MultipleTicketsPopup,
  [POPUPS.TERMINAL_LOCK_REMINDER]: TerminalLockReminderPopup,
  [POPUPS.SHOW_PAYMENT_POPUP]: () => <span className="money" />,
  [POPUPS.TICKET_DETAILS_POPUP]: TicketDetailsPopup, // not need
  [POPUPS.CHECK_TICKET_POPUP]: CheckTicketPopup, // not need
  [POPUPS.REGISTER_BY_CNP_POPUP]: RegisterByCNPPopup,
  [POPUPS.RFID_CHECK_POPUP]: RfidCheck,
  [POPUPS.REGISTER_SUCCESS]: RegisterSuccess,
  [POPUPS.WIN_IDENTIFICATION]: WinIdentificationPopup,
  [POPUPS.CNP_VERIFICATION]: CnpVerificationPopup,
  [POPUPS.PRINT_BOOKING_TICKET]: PrintBookingTicket,
  [POPUPS.PASSPORT_VERIFICATION_INACTIVE]: VerificationInactive,
  [POPUPS.PASSPORT_VERIFICATION]: PassportVerificationInfo,
  [POPUPS.PASSPORT_VERIFICATION_LOADING]: VerificationLoading,
  [POPUPS.PASSPORT_VERIFICATION_SUCCESS]: VerificationSuccess,
  [POPUPS.PASSPORT_VERIFICATION_LOGOUT]: VerificationLogOut,
  [POPUPS.PROFIT_BOOST_WHEEL]: ProfitBoostWheel,
  [POPUPS.PROFIT_BOOST_INFO]: ProfitBoostInfo,
  [POPUPS.REQUEST_PAYOUT]: PayoutRequest,
  [POPUPS.WITHDRAWAL]: WithdrawalAmountPopup,
  [POPUPS.WITHDRAWAL_CONFIRM_POPUP]: WithdrawalConfirmPopup,
  [POPUPS.IFRAME_POPUP]: IframePopup,
  [POPUPS.EMBED_POPUP]: EmbedPopup,
  [POPUPS.VERIFICATION]: VerificationPopup,
  [POPUPS.INFO]: InfoPopup,
  [POPUPS.VERIFICATION_LOGOUT]: VerificationLogoutPopup,
  [POPUPS.CASHOUT_BY_OCTO]: CashoutOctopay,
  [POPUPS.NON_CASH_INACTIVE_POPUP]: NonCashInactivePopup,
  [POPUPS.REGISTRATION_FORM]: RegistrationForm,
  [POPUPS.PROCESS_POPUP]: ProcessPopup,
  [POPUPS.CLIENT_DEPOSIT_POPUP]: ClientDepositPopup,
  [POPUPS.CLIENT_DEPOSIT_FAIL_POPUP]: ClientDepositFailPopup,
  [POPUPS.TRANSFER_TO_USER]: TransferToUser,
  [POPUPS.JACKPOT_LIST_POPUP]: JackpotListPopup,
  [POPUPS.DIGITAL_CASHOUT]: DigitalCashout,
};
